import { FormRow, FormSection } from '@shared/components';
import { usePostalLookup } from '@modules/integration';
import type { CustomerCreateInput } from '../services/customer.service';

const cls = 'w-full border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500';

interface Props {
  form: CustomerCreateInput;
  upd: (patch: Partial<CustomerCreateInput>) => void;
}

export function CustomerFormFieldsAddress({ form, upd }: Props) {
  // 仕入先（通販業者を含む）にチェックがある場合は郵便番号の必須を解除する。
  const isSupplier = form.partnerTypes?.includes('supplier') ?? false;
  const { lookup, loading } = usePostalLookup();

  // 郵便番号が7桁になったら住所を自動補完（都道府県・市区町村）。番地・建物名は手入力。
  const handlePostalChange = (value: string) => {
    upd({ postalCode: value });
    if (value.replace(/-/g, '').length === 7) {
      void lookup(value).then((r) => {
        if (r) upd({ prefecture: r.prefecture, addr1: `${r.city}${r.town}` });
      });
    }
  };

  return (
    <FormSection title="住所">
      <FormRow label="郵便番号" required={!isSupplier}>
        <div className="flex items-center gap-2">
          <input
            className={cls}
            value={form.postalCode}
            required={!isSupplier}
            placeholder="例: 100-0001"
            onChange={(e) => handlePostalChange(e.target.value)}
          />
          {loading && <span className="text-xs text-gray-500 whitespace-nowrap">検索中…</span>}
        </div>
      </FormRow>
      <FormRow label="都道府県">
        <input
          className={cls}
          value={form.prefecture}
          onChange={(e) => upd({ prefecture: e.target.value })}
        />
      </FormRow>
      <FormRow label="住所（市区町村）">
        <input
          className={cls}
          value={form.addr1}
          onChange={(e) => upd({ addr1: e.target.value })}
        />
      </FormRow>
      <FormRow label="住所（番地）">
        <input
          className={cls}
          value={form.addr2}
          onChange={(e) => upd({ addr2: e.target.value })}
        />
      </FormRow>
      <FormRow label="住所（建物名・フロア）">
        <input
          className={cls}
          value={form.addr3}
          onChange={(e) => upd({ addr3: e.target.value })}
        />
      </FormRow>
      <FormRow label="部署">
        <input
          className={cls}
          value={form.department}
          onChange={(e) => upd({ department: e.target.value })}
        />
      </FormRow>
    </FormSection>
  );
}
